import {createContext} from 'react'

const PizzaContext = createContext(null)

export default PizzaContext